import React, { useContext, useEffect } from 'react';
import { Form, Input, Button, message, Row, Col, Breadcrumb, Select } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { UserService } from '../../common/services';
import { AuthContext } from '../../common/constants';
import { toast } from 'react-toastify';

const Profile = () => {
    const [form] = Form.useForm();
    // const [loading, setLoading] = useState(false);
    // const navigate = useNavigate();
    const { currentUser } = useContext(AuthContext);

    useEffect(() => {
        if (currentUser) {
            form.setFieldsValue({
                firstName: currentUser.firstName,
                lastName: currentUser.lastName,
                phone: currentUser.phone?.replace('+225', '') || '',
                email: currentUser.email,
                residence: currentUser.residence,
                country: currentUser.country || 'civ'
            });
        }
    }, [currentUser, form]);

    const handleSubmit = async (values) => {
        if (values.password && values.password !== values.confirmPassword) {
            return message.error("Les mots de passe ne correspondent pas");
        }

        const finalValues = {
            ...values,
            phone: `+225${values.phone}`
        };

        try {
            await UserService.miseAjourProfileAdmin(currentUser._id, finalValues);
            message.success('Profile mis à jour avec succès');
        } catch (error) {
            const errorMessage = error.message || 'Une erreur est survenue lors de la connexion.';
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 5000,
            });
            // console.error(error);
            // message.error("Erreur lors de la mise à jour du profil");
        }
    };

    return (
        <div className="container-xxl flex-grow-1 container-p-y">
            <Breadcrumb
                separator={<RightOutlined style={{ fontSize: '16px', color: '#999', fontWeight: 'bolder' }} />}
                style={{ marginBottom: 16 }}
            >
                <Breadcrumb.Item>
                    <Link to="/dashboard" style={{ fontSize: '16px', fontWeight: 'bolder' }}>🏠 ACCUEIL</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>👤 MON PROFIL</span>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div className="card">
                <div className="card-body">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        validateTrigger={['onChange', 'onBlur']}
                    >
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    name="firstName"
                                    label="Nom"
                                    rules={[{ required: true, message: 'Veuillez entrer le nom' }]}
                                    normalize={v => v?.toUpperCase()}
                                >
                                    <Input placeholder="Ex : KOUADIO" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="lastName"
                                    label="Prénoms"
                                    rules={[{ required: true, message: 'Veuillez entrer le prénom' }]}
                                    normalize={v => v?.toUpperCase()}
                                >
                                    <Input placeholder="Ex : JEAN MICHEL" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="phone"
                                    label="Téléphone"
                                    rules={[
                                        { required: true, message: 'Veuillez entrer le numéro de téléphone' },
                                        { pattern: /^[0-9]{10}$/, message: 'Le numéro doit contenir exactement 10 chiffres' }
                                    ]}
                                >
                                    <Input addonBefore="+225" maxLength={10} placeholder="Ex : 0102030405" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="email"
                                    label="Email"
                                    rules={[{ type: 'email', message: 'Format email invalide' }]} // facultatif
                                >
                                    <Input type="email" placeholder="exemple@domaine.com" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="residence"
                                    label="Résidence"
                                >
                                    <Input placeholder="Ex : Yopougon" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="country"
                                    label="Pays"
                                >
                                    <Select>
                                        <Select.Option value="civ">Côte d'Ivoire</Select.Option>
                                        <Select.Option value="fr">France</Select.Option>
                                        <Select.Option value="us">USA</Select.Option>
                                        <Select.Option value="uk">UK</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="password"
                                    label="Nouveau mot de passe"
                                >
                                    <Input.Password placeholder="********" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="confirmPassword"
                                    label="Confirmer mot de passe"
                                >
                                    <Input.Password placeholder="********" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" >
                                        Enregistrer les modifications
                                    </Button>
                                </Form.Item>

                            </Col>
                        </Row>

                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Profile;
